import React, { Component } from 'react'
import StandingsTable from '../../../../../../../TablaDePosiciones/Components/StandingsTable'
import Legend from '../../../../../../../TablaDePosiciones/Components/Legend'
import ScrollIndicator from '../../../../../../../TablaDePosiciones/Components/ScrollIndicator'
import Device from '../../../../../../../../../devices/device'
import './_styles.scss'
import getCurrentStageCode from '../../../../../../../services/getCurrentStageCode'
import { FASES_DE_GRUPOS, FASE_DE_GRUPOS_2 } from '../../../../../../../constants'
import { getNodeCode, sendMetricScroll } from '../../../../../../../utils'
import Utils from '../../../../../../../../../utils/Utils'
import { getStandingsCountryDetail } from '../../../../../../../services/CountryDetailsServices/getStandingsCountryDetail'
import { CLASSIFICATION, RANKINGS } from './constants'
import Translator from '../../../../../../../../../requests/apa/Translator'
import logger from 'src/utils/logger/logger';

class StandingsBody extends Component {
	constructor (props) {
		super(props)
		this.state = {
			groupScrollTop: 0,
			groupMaxScroll: 0,
			rankingScrollTop: 0,
			rankingMaxScroll: 0,
			title: '',
			teams: [],
			headers: [],
			isGroup: false
		}
		this.handleGroupKeyDown = this.handleGroupKeyDown.bind(this)
		this.handleRankingKeyDown = this.handleRankingKeyDown.bind(this)
		this.groupsRef = null
		this.groupScrollRef = null
		this.rankingScrollRef = null
		this.keys = Device.getDevice().getKeys()
		this.groupScrollMilestonesSent = new Set()
		this.rankingScrollMilestonesSent = new Set()


        const code = getNodeCode()
        const metadataValue = Utils.getApaMetadataKey('sports_competition_config', null)
        this.idLeague = metadataValue && metadataValue[code] ? metadataValue[code].leagueId : null
		logger.debug('StandingsBody', this.idLeague)
	}

	async componentDidMount() {
		const currentStage = await getCurrentStageCode(this.idLeague)
		await this.getStandingsData(currentStage === FASES_DE_GRUPOS || currentStage === FASE_DE_GRUPOS_2)
	}

	getStandingsData = async (isGroupStage) => {
		const { teams, title, headers } = await getStandingsCountryDetail(this.idLeague, isGroupStage ? CLASSIFICATION : RANKINGS, this.props.countryId)
		this.groupScrollMilestonesSent = new Set()
		this.rankingScrollMilestonesSent = new Set()
		this.setState({ teams, isGroup: isGroupStage, title, headers, groupScrollTop: 0, groupMaxScroll: 0, rankingScrollTop: 0, rankingMaxScroll: 0 })
	}

	handleGroupKeyDown (e) {
		const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null
		if (!currentKey) return

		const el = this.groupScrollRef
		const firstRow = el ? el.querySelector('.standings-table__row') : null
		const actualRowPx = firstRow ? firstRow.offsetHeight : 58
		const STEP = actualRowPx * 2
		const MAX_SCROLL = el ? el.scrollHeight - el.clientHeight : 0
		var next = this.state.groupScrollTop

		if (currentKey === 'UP') {
			e.preventDefault()
			e.stopPropagation()
			if (this.state.groupScrollTop === 0) {
				var mainMenuTab = document.querySelector('.country-details-body__tabs .focusable')
				// var mainMenuTab = activeText ? activeText.closest('.focusable') : null
				if (mainMenuTab) mainMenuTab.focus()
				return
			}
			next = Math.max(0, next - STEP)
		} else if (currentKey === 'DOWN') {
			e.preventDefault()
			e.stopPropagation()
			next = Math.min(MAX_SCROLL, next + STEP)
		} else if (currentKey === 'RIGHT') {
			e.preventDefault()
			e.stopPropagation()
			var activeText = document.querySelector('.country-details-body__tabs .main-menu__item-text--active')
			var mainMenuTab = activeText ? activeText.closest('.focusable') : null
			if (mainMenuTab) mainMenuTab.focus()
			return
		} else {
			return
		}

		this.setState({ groupScrollTop: next, groupMaxScroll: MAX_SCROLL })
		if (this.groupScrollRef) this.groupScrollRef.scrollTop = next

		const prevPercent = MAX_SCROLL > 0 ? Math.round(this.state.groupScrollTop / MAX_SCROLL * 100) : 0
		const nextPercent = MAX_SCROLL > 0 ? Math.round(next / MAX_SCROLL * 100) : 0

		const mainMenuLabel =  this.props.mainMenuLabel
		const parentTabLabel = this.props.parentTabLabel
		const childTabLabel = this.props.childTabLabel

		if (currentKey === 'DOWN') {
			const MILESTONES = [25, 50, 75]
			MILESTONES.forEach(m => {
				if (prevPercent < m && m <= nextPercent && !this.groupScrollMilestonesSent.has(m)) {
					this.groupScrollMilestonesSent.add(m)
					sendMetricScroll(mainMenuLabel, parentTabLabel, childTabLabel, m)
				}
			})
			if (next >= MAX_SCROLL && !this.groupScrollMilestonesSent.has(100)) {
				this.groupScrollMilestonesSent.add(100)
				sendMetricScroll(mainMenuLabel, parentTabLabel, childTabLabel, 100)
			}
		} else {
			if (prevPercent === 100 && nextPercent < 100) {
				this.groupScrollMilestonesSent.delete(100)
			}
			const MILESTONES = [25, 50, 75]
			MILESTONES.forEach(m => {
				if (nextPercent < m && m <= prevPercent && this.groupScrollMilestonesSent.has(m)) {
					this.groupScrollMilestonesSent.delete(m)
					sendMetricScroll(mainMenuLabel, parentTabLabel, childTabLabel, m)
				}
			})
		}
	}

	handleRankingKeyDown (e) {
		const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null
		if (!currentKey) return

		const el = this.rankingScrollRef
		const firstRow = el ? el.querySelector('.standings-table__row') : null
		const actualRowPx = firstRow ? firstRow.offsetHeight : 58
		const STEP = actualRowPx * 5
		const MAX_SCROLL = el ? el.scrollHeight - el.clientHeight : 0
		var next = this.state.rankingScrollTop

		if (currentKey === 'UP') {
			e.preventDefault()
			e.stopPropagation()
			if (this.state.rankingScrollTop === 0) {
				var mainMenuTab = document.querySelector('.country-details-body__tabs .focusable')
				// var mainMenuTab = activeText ? activeText.closest('.focusable') : null
				if (mainMenuTab) mainMenuTab.focus()
				return
			}
			next = Math.max(0, next - STEP)
		} else if (currentKey === 'DOWN') {
			e.preventDefault()
			e.stopPropagation()
			next = Math.min(MAX_SCROLL, next + STEP)
		} else if (currentKey === 'RIGHT') {
			e.preventDefault()
			e.stopPropagation()
			var activeText = document.querySelector('.country-details-body__tabs .main-menu__item-text--active')
			var mainMenuTab = activeText ? activeText.closest('.focusable') : null
			if (mainMenuTab) mainMenuTab.focus()
			return
		} else {
			return
		}

		this.setState({ rankingScrollTop: next, rankingMaxScroll: MAX_SCROLL })
		if (this.rankingScrollRef) this.rankingScrollRef.scrollTop = next

		const prevPercent = MAX_SCROLL > 0 ? Math.round(this.state.rankingScrollTop / MAX_SCROLL * 100) : 0
		const nextPercent = MAX_SCROLL > 0 ? Math.round(next / MAX_SCROLL * 100) : 0

		const mainMenuLabel =  this.props.mainMenuLabel
		const parentTabLabel = this.props.parentTabLabel
		const childTabLabel = this.props.childTabLabel

		if (currentKey === 'DOWN') {
			const MILESTONES = [25, 50, 75]
			MILESTONES.forEach(m => {
				if (prevPercent < m && m <= nextPercent && !this.rankingScrollMilestonesSent.has(m)) {
					this.rankingScrollMilestonesSent.add(m)
					sendMetricScroll(mainMenuLabel, parentTabLabel, childTabLabel, m)
				}
			})
			if (next >= MAX_SCROLL && !this.rankingScrollMilestonesSent.has(100)) {
				this.rankingScrollMilestonesSent.add(100)
				sendMetricScroll(mainMenuLabel, parentTabLabel, childTabLabel, 100)
			}
		} else {
			if (prevPercent === 100 && nextPercent < 100) {
				this.rankingScrollMilestonesSent.delete(100)
			}
			const MILESTONES = [25, 50, 75]
			MILESTONES.forEach(m => {
				if (nextPercent < m && m <= prevPercent && this.rankingScrollMilestonesSent.has(m)) {
					this.rankingScrollMilestonesSent.delete(m)
					sendMetricScroll(mainMenuLabel, parentTabLabel, childTabLabel, m)
				}
			})
		}
	}

	render () {
		const { groupScrollTop, groupMaxScroll, rankingScrollTop, rankingMaxScroll, isGroup, teams, title, headers } = this.state
		const {countryId} = this.props
		logger.debug(countryId)
        // isGroup si es true muestra la tabla de posiciones por grupos, si es false muestra el ranking general de selecciones
		const groupScrollRatio = groupMaxScroll > 0 ? groupScrollTop / groupMaxScroll : 0
		const rankingScrollRatio = rankingMaxScroll > 0 ? rankingScrollTop / rankingMaxScroll : 0

		const leftItems = [
			{ key: 'pts',   label: Utils.cutPlayerString('PTS', 5),   description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_puntos'), 30) },
			{ key: 'ptd', label: Utils.cutPlayerString('PTD', 5), description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_partidosdisputados'), 30) },
			{ key: 'g',  label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_goles'), 5),  description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_goles'), 30) },
			{ key: 'e', label: Utils.cutPlayerString('E', 5), description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_empatados'), 30) }
		]
		const rightItems = [
			{ key: 'p',  label: Utils.cutPlayerString('P', 5),  description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_perdidos'), 30) },
			{ key: 'gf',  label: Utils.cutPlayerString('GF', 5),  description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_golesafavor'), 30) },
			{ key: 'gc',  label: Utils.cutPlayerString('GC', 5),  description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_golesencontra'), 30) },
			{ key: 'gd',  label: Utils.cutPlayerString('GD', 5),  description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_diferenciadegoles'), 30) }
		]

		return (
			<div className='standings-body'>
                {
                    isGroup ?
                    // <div className='standings-body__content'>
                        <div className='standings-body__group-wrapper'>
                            <div className='standings-body__group-table'>
                                <p className='standings-body__group-title'>{title}</p>
                                <StandingsTable
                                    rows={teams}
                                    headers={headers}
                                    bodyRef={function (el) { this.groupScrollRef = el }.bind(this)}
                                    bodyClassName='standings-body__group-scroll'
                                    footer={<div style={{ paddingBottom: '4rem' }}><Legend leftItems={leftItems} rightItems={rightItems} /></div>}
									highlightTeamId={countryId}
  									highlightColor="rgba(247, 127, 3, 0.20)"
                                />
                            </div>
                            <ScrollIndicator
                                onKeyDown={this.handleGroupKeyDown}
                                scrollRatio={groupScrollRatio}
                                className='standings-body__group-scrollbar'
                                trackHeightRem={34.67}
                                thumbHeightRem={11.4}
                            />
                        </div>
                    // </div>
                    :
                    <div className='standings-body__ranking-wrapper'>
                        <div className='standings-body__ranking-table'>
                            <p className='standings-body__ranking-title'>{title}</p>
                            <StandingsTable
                                rows={teams}
                                headers={headers}
                                bodyClassName='standings-body__ranking-scroll'
                                bodyRef={function (el) { this.rankingScrollRef = el; if (el) el.scrollTop = this.state.rankingScrollTop }.bind(this)}
                                footer={<div style={{ paddingBottom: '9rem' }}><Legend leftItems={leftItems} rightItems={rightItems} /></div>}
								highlightTeamId={countryId}
								highlightColor="rgba(247, 127, 3, 0.20)"
                            />
                        </div>
                        <ScrollIndicator
                            onKeyDown={this.handleRankingKeyDown}
                            scrollRatio={rankingScrollRatio}
                            className='standings-body__ranking-scrollbar'
                            trackHeightRem={34.67}
                            thumbHeightRem={11.4}
                        />
                    </div>
                }
			</div>
		)
	}
}

export default StandingsBody



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsBody/Components/StandingsBody/index.jsx